import React, { useState, useEffect } from 'react';
import braintree from 'braintree-web';
import { Col, Row } from 'reactstrap';
import '../assets/css/BraintreeStyles.css'; // Import the external styles
import { useMutation } from '@apollo/client';
import { SEND_SINGLE_BRAINTREE_TRANSACTION } from '../graphql/mutations/braintree';

const BraintreePayment = () => {
  const [hostedFieldsInstance, setHostedFieldsInstance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [theCardToken, setCardToken] = useState(null);
  const [formError, setformError] = useState("Enter your card information");
  const [postalCode, setPostalCode] = useState(""); // Track postal code value in state
  
  useEffect(() => {
    const clientToken = process.env.REACT_APP_BRAINTREE_TOKEN; // Replace with your actual token
console.log("Use Effectt");
    // Create Braintree client and initialize Hosted Fields
    braintree.client.create(
      {
        authorization: clientToken,
      },
      (err, clientInstance) => {
        if (err) {
          // console.error('Error creating client:', err);
          return;
        }

        braintree.hostedFields.create(
          {
            client: clientInstance,
            styles: {
              'input': {
                'font-size': '14px',
                'color': '#282c34',
              },
              ':focus': {
                'color': '#282c34'
              },
              '.valid': {
                'color': 'green'
              },
              '.invalid': {
                'color': 'red'
              }
            },
            fields: {
              number: {
                selector: '#card-number',
                placeholder: '**** **** **** ****',
              },
              cvv: {
                selector: '#cvv',
                placeholder: 'cvv',
              },
              expirationDate: {
                selector: '#expiration-date',
                placeholder: 'mm / yy',
              },
              // postalCode: {
              //   selector: '#postal-code',
              //   placeholder: '12345',
              // },
            },
          },
          (err, hostedFieldsInstance) => {
            if (err) {
              // console.error('Error creating Hosted Fields:', err);
              return;
            }
            setHostedFieldsInstance(hostedFieldsInstance);
          }
        );
      }
    );
  }, [loading]);

  // Handle postal code input
  const handlePostalCodeChange = (event) => {
    const maxLength = 5; // Set your max postal code length here
    const value = event.target.value;
    
    if (value.length <= maxLength) {
      setPostalCode(value); // Only update postal code if it's within the limit
    }
  };

  // Tokenize card details
  const tokenizeCard = async () => {
    if (!hostedFieldsInstance) {
      return;
    }

    try {
      const payload = await hostedFieldsInstance.tokenize();
      // console.log("GeneratedToken", payload);
      return ({
        token: payload.nonce, 
        bin: payload.details.bin,
        exp_month: payload.details.expirationMonth,
        exp_year: payload.details.expirationYear,
        lastFour: payload.details.lastFour
      });
    } catch (err) {
      // console.log("err", err);
      setformError('please check your card details.');
      return null;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate postal code before submitting
    if (postalCode.length !== 5) {
      setformError('invalid postal code.');
      return;
    }
    
    const token = await tokenizeCard();
    if (token) {

      // console.log('Tokenized card nonce:', token);
      setCardToken(token); // This is your token to send to your server
      setTimeout(() => {
        // console.log("TheToken", token)
        SendIFrameMessage(null, "SendBillingData");
      }, 1000)
    } else {
      setPostalCode(""); 
      setformError('please check your card details.');
    }

    // Reset Hosted Fields after success
    hostedFieldsInstance.clear('number');
    hostedFieldsInstance.clear('cvv');
    hostedFieldsInstance.clear('expirationDate');
    // hostedFieldsInstance.clear('postalCode');
  };

  const [sendSingleBrainTreeTransaction] = useMutation(SEND_SINGLE_BRAINTREE_TRANSACTION);

  const SendIFrameMessage = (data, action) => {
    window.parent.postMessage({ type: 'FROM_IFRAME', payload: { data: data, action: action } }, process.env.REACT_APP_WOWCLOUD_PARENT + '/checkout/ed00261a-87f6-4744-8915-e2d4f40b1111'); //Parent
  }

  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_WOWCLOUD_PARENT) return; //Parent
  
      const { type, payload } = event.data;

      if (type === 'FROM_PARENT') {
        if(payload.action === "SendBillingData"){
          const serverPayload = {
            token: theCardToken.token,
            paymentdata: {
              firstname: payload.data.firstname,
              lastname: payload.data.lastname,
              address: payload.data.address1,
              address2: payload.data.address2,
              city: payload.data.city,
              state: payload.data.state,
              zip: parseInt(postalCode),
              phone: payload.data.phone,
              email: payload.data.email,
              country: "US",
              price: parseInt(payload.data.price),
              expMonth: parseInt(theCardToken.exp_month),
              expYear: parseInt(theCardToken.exp_year),
              lastFour: parseInt(theCardToken.lastFour),
              bin: theCardToken.bin,
              paymentid: payload.data.paymentid,
              productid: payload.data.productid,
              refid: payload.data.refid,
              shortdescription: payload.data.shortdescription,
              existingcustomer: payload.data.existingcustomer,
              referral: payload.data.referral,
            }
          }
          setLoading(true);
          setPostalCode(""); 
          SendSingleTransaction(serverPayload)
        }
        else if(payload.action == "Reset"){
          setLoading(false);
        }
      }
    };
  
    window.addEventListener('message', handleIframeMessage);
  
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [theCardToken]);

  const SendSingleTransaction = (serverPayload) => {
    sendSingleBrainTreeTransaction({ variables: {token: serverPayload.token, paymentdata: serverPayload.paymentdata}})
    .then((tres) => {
      if(tres.data.sendSingleBrainTreeTransaction.status){
        SendIFrameMessage(tres.data.sendSingleBrainTreeTransaction.data, "TransactionSuccess")
        // setLoading(false);
      }
      else{
        if(tres.data.sendSingleBrainTreeTransaction.error === "CardValidationRequired"){
          SendIFrameMessage(tres.data.sendSingleBrainTreeTransaction.error, "CardValidationRequired")
          setLoading(false);
        }
        else{
          SendIFrameMessage(tres.data.sendSingleBrainTreeTransaction.error, "TransactionError")
          setLoading(false);
        }
      }
    })
    .catch((err) => {
      // console.log("ERROR2", err)
    })
    .finally(() =>{
      //TODO: Set loading
    })
  }
  //end of custom stuff

  return (
    <div className="mwContainer">
        {loading &&
          <Row>
            <Col md = "12">
              <h1>Processing ...</h1>
            </Col>
          </Row>
        } 
          
        {!loading &&
        <form onSubmit={handleSubmit} className="payment-form">
          <div className="card-container">
            <div id="card-number" className="form-control"></div>
            <Row>
              <div id="expiration-date" className="form-control small-input"></div>
              <div id="cvv" className="form-control small-input"></div>
              <input
                type="text"
                id="postal-code"
                className="form-control small-input"
                value={postalCode}
                onChange={handlePostalCodeChange}
                placeholder="zip"
              />
            </Row>

            <div className="card-input">
              <label htmlFor="expMonth" className="small-input">
                Exp. Date
              </label>

              <label htmlFor="cardCode" className="small-input">
                CVV
              </label>

              <label htmlFor="zipCode" className="small-input">
                Zip
              </label>
            </div>
          </div>

          <div className="error-message">
            {formError && <p>{formError}</p>}
          </div>

            <button type="submit" className="submit-btn">
              Pay
            </button>
        </form>
        }

    </div>
  );
};

export default BraintreePayment;
